import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Dashboard from "../pages/dashboard/page";
import ProjectDetails from "../pages/project-details/page";
import Profile from "../pages/profile/page";
import Help from "../pages/help/page";
import Reports from '../pages/reports/page';
import AdminPage from "../pages/admin/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/dashboard",
    element: <Dashboard />,
  },
  {
    path: "/project/:id",
    element: <ProjectDetails />,
  },
  {
    path: "/profile",
    element: <Profile />,
  },
  {
    path: "/help",
    element: <Help />,
  },
  {
    path: "/reports",
    element: <Reports />
  },
  {
    path: "/admin",
    element: <AdminPage />
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;